import { render, staticRenderFns } from "./TbUsers.vue?vue&type=template&id=512d6ff2"
import script from "./TbUsers.vue?vue&type=script&lang=js"
export * from "./TbUsers.vue?vue&type=script&lang=js"
import style0 from "./TbUsers.vue?vue&type=style&index=0&id=512d6ff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports